export default {
  home: {
    ignore: true
  },
  users: {
    action: "UserList",
    subject: "users",
    ignore: false
  },
  roles: {
    action: "RoleList",
    subject: "roles",
    ignore: false
  },
  permissions: {
    action: "UserList",
    subject: "users",
    ignore: false
  },
  shops: {
    action: "ShopList",
    subject: "shops",
    ignore: false
  },
  devices: {
    action: "DeviceList",
    subject: "devices",
    ignore: true     // ignore missing permissions and display always
  },
  "shop-groups": {
    action: "ShopGroupList",
    subject: "shopgroups",
    ignore: false
  },
  tenants: {
    action: "TenantList",
    subject: "tenants",
    ignore: false
  },
  companies: {
    action: "CompanyList",
    subject: "companies",
    ignore: false,
  },
  products: {
    action: "ProductList",
    subject: "products",
    ignore: false, // TODO: add company permission
  },
  profile: {
    ignore: true
  },
  backoffice: {
    action: "RegistryList",
    subject: "registry",
    ignore: false
  },
  countries: {
    action: "CountryList",
    subject: "countries",
    ignore: false
  },
  "lottery-systems": {
    action: "LotoSystemList",
    subject: "lotosystems",
    ignore: false
  },
  "lottery-events": {
    action: "LotoEventList",
    subject: "lotoevents",
    ignore: false
  },
  tickets: {
    action: "LotoTicketList",
    subject: "lototickets",
    ignore: false
  },
  "ticket-authorizations": {
    action: "LotoTicketAuthz",
    subject: "lototickets",
    ignore: false
  },
  firewalls: {
    action: "LotoFirewallList",
    subject: "lotofirewalls",
    ignore: false
  },
  players: {
    action: "PlayerList",
    subject: "players",
    ignore: false
  },
  "online-players": {
    action: "OnlinePlayerList",
    subject: "onlineplayers",
    ignore: false
  },
  "third-party-players": {
    action: "ThirdPartyPlayerList",
    subject: "thirdpartyplayers",
    ignore: false
  },
  audits: {
    action: "AuditLogList",
    subject: "audit",
    ignore: false
  },
  "cash-results": {
    action: "LotteryFinancialReport",
    subject: "lotoreports",
    ignore: false
  },
  "expired-winnings": {
    action: "LotteryFinancialReport",
    subject: "lotoreports",
    ignore: false
  },
  "lottery-offers": {
    action: "ProductReports",
    subject: "lotoreports",
    ignore: false
  },
  "lottery-results": {
    action: "ProductReports",
    subject: "lotoreports",
    ignore: false
  },
  "lottery-systems-performance": {
    action: "LotteryFinancialReport",
    subject: "lotoreports",
    ignore: false
  },
  "return-players": {
    action: "LotteryFinancialReport",
    subject: "lotoreports",
    ignore: false
  },
  "taxed-paid-ticket": {
    action: "LotteryFinancialReport",
    subject: "lotoreports",
    ignore: false
  },
  "income-payments": {
    action: "FinancialReports",
    subject: "lotoreports",
    ignore: false
  },
  "device-income-payments": {
    action: "FinancialReports",
    subject: "lotoreports",
    ignore: true // ignore missing permissions and display always
  },
  "daily-monthly-income": {
    action: "FinancialReports",
    subject: "lotoreports",
    ignore: false
  },
  "cash-register": {
    action: "FinancialReports",
    subject: "lotoreports",
    ignore: false
  },
  "income-winnings": {
    action: "FinancialReports",
    subject: "lotoreports",
    ignore: false
  },
  "banks": {
    action: "BankDetailList",
    subject: "bankdetails",
    ignore: false
  },
  "operators": {
    action: "CashOperatorList",
    subject: "cashoperators",
    ignore: false
  },
  "subtypes": {
    action: "CashTxSubtypeList",
    subject: "cashtxsubtypes",
    ignore: false
  },
  "slots": {
    action: "SlotList",
    subject: "slots",
    ignore: false
  },
  "shop-balance": {
    action: "ShopBalanceList",
    subject: "shopbalance",
    ignore: false
  },
  "shop-balance-tx": {
    action: "ShopBalanceTxList",
    subject: "shopbalancetx",
    ignore: false
  },
  "cash-required": {
    action: "LotteryFinancialReport",
    subject: "lotoreports",
    ignore: false,
  },
  "api-imports": {
    action: "LotteryFinancialReport",
    subject: "lotoreports",
    ignore: false,
  },
  "cash-operations": {
    action: "ShopCashTransactionList",
    subject: "shopcashtx",
    ignore: false,
  },
  "epos-operations": {
    action: "EPOSTransactionList",
    subject: "epos",
    ignore: false,
  },
  "online-cash-transactions": {
    action: "OnlineCashTransactionList",
    subject: "onlinecashtx",
    ignore: true,
  },
  "user-activity": {
    action: "UserActivityList",
    subject: "audit",
    ignore: false,
  },
  "user-clocking": {
    action: "UserActivityReport",
    subject: "reports",
    ignore: false,
  },
  "user-activity-manual": {
    action: "UserActivityManualList",
    subject: "useractivitymanual",
    ignore: false,
  },
  "user-clocking-manual": {
    action: "UserActivityManualReport",
    subject: "reports",
    ignore: false,
  },
  "terminal-activity": {
    action: "TerminalActivityReport",
    subject: "reports",
    ignore: false,
  },
  "manual-report": {
    action: "AddManualFinancialReport",
    subject: "freports",
    ignore: false,
  },
  "recompute-shop-balance": {
    action: "RecomputeShopBalance",
    subject: "admin",
    ignore: false,
  },
  "operators-report": {
    action: "OperatorsReport",
    subject: "freports",
    ignore: true,
  },
  "online-payouts": {
    action: "OnlinePayoutList",
    subject: "online",
    ignore: false,
  },
  "jackpots": {
    action: "JackpotList",
    subject: "freports",
    ignore: true,
  },
  "jackpots-history": {
    action: "JackpotHistoryList",
    subject: "freports",
    ignore: true,
  },
  "raffle": {
    action: "RaffleClientsList",
    subject: "raffle",
    ignore: false,
  },
  "raffle-serials": {
    action: "RaffleSerialsList",
    subject: "raffle",
    ignore: false,
  },
  "shop-visits": {
    action: "ShopVisitsList",
    subject: "shopvisits",
    ignore: false,
  },
};
